var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c("v-col", [
            _c(
              "p",
              [
                _vm.insTagWarnings.length > 0
                  ? _c(
                      "v-alert",
                      { attrs: { type: "warning" } },
                      _vm._l(_vm.insTagWarnings, function(warning) {
                        return _c("p", { staticClass: "mb-0" }, [
                          _vm._v(
                            "\n            " + _vm._s(warning) + "\n          "
                          )
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-textarea",
                  _vm._b(
                    {
                      staticClass: "campaign-parameter-ins-tag",
                      attrs: {
                        dense: "",
                        typeof: "text",
                        label: _vm.formatParameter.description
                      },
                      model: {
                        value: _vm.str,
                        callback: function($$v) {
                          _vm.str = $$v
                        },
                        expression: "str"
                      }
                    },
                    "v-textarea",
                    _vm.$attrs,
                    false
                  )
                ),
                _vm._v(" "),
                _vm.replaceableTags.length > 0
                  ? _c("v-container", [
                      _c("span", [
                        _vm._v("Foreign macros detected click to replace: ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-2" },
                        _vm._l(_vm.replaceableTags, function(item) {
                          return _c(
                            "v-btn",
                            {
                              staticClass: "ml-1 mr-1 mb-3",
                              on: {
                                click: function($event) {
                                  return _vm.replaceTag(item.key)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.key) +
                                  " => " +
                                  _vm._s(item.value) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "d-flex button_bottom_align", attrs: { cols: "1" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    disabled: !_vm.isDeleteAvailable,
                    color: "white",
                    title: "Reset to default format value"
                  },
                  on: { click: _vm.onTextClear }
                },
                [_c("v-icon", [_vm._v("mdi-undo")])],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }